import React from 'react';

function SubHeaderBanner({ message }) {
  return (
    <section className='grid grid-cols-[1fr_auto_1fr] gap-x-4 items-center text-center lg:px-6'>
      <div className='grid border-t-[1px] border-solid border-colour8 min-w-6'></div>
      <div>
        <h1 className='text-2xl uppercase'>{message}</h1>
      </div>
      <div className='grid border-t-[1px] border-solid border-colour8 min-w-6'></div>
    </section>
  );
}

export default SubHeaderBanner;
